/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { FabNavItem } from '@fabric/components/common';

export const appNavItems: FabNavItem[] = [
  {
    name: 'Home',
    route: '',
    iconName: 'home',
  },
  {
    name: 'Model Selector',
    route: 'model-selector',
    iconName: 'dashboard',
  },
];
